__turbopack_context__.v({
  "className": "roboto_eb17f30c-module__RWXOGa__className",
  "variable": "roboto_eb17f30c-module__RWXOGa__variable",
});
